import { $, $$, sleep, toSeconds } from '../_utils'

const submitBtn = $('button[type="submit"]')
const questions = $$('fieldset.questionnaire__question')

const init = () => {
  submitBtn.addEventListener('click', send)
  questions.forEach(function (question) {
    const type = question.dataset.type

    if (type === 'closed' || type === 'semi-open') {
      bindCheckboxAction(question)
    } else {
      bindTextareaAction(question)
    }
  })
}

const validateQuestion = question => {
  const type = question.dataset.type
  const required = question.dataset.required === 'true'
  const min = question.dataset.min == undefined ? false : question.dataset.min
  const max = question.dataset.max == undefined ? false : question.dataset.max

  let error = false
  if (type === 'open') {
    const textarea = $('textarea', question)

    if (required === true || textarea.value.length > 0) {
      if (min && textarea.value.length < min) {
        error = true
      }

      if (max && textarea.value.length > max) {
        error = true
      }
    }

    if (error) {
      textarea.classList.add('invalid')
      window.scrollTo({
        top: question.offsetTop - 125,
        behavior: 'smooth',
      })
    } else {
      textarea.classList.remove('invalid')
    }
  } else {
    let answers = $$('input[type=checkbox]', question)
    let checkedNumber = 0

    answers.forEach(function (answer) {
      const otherInput = $(
        answer.dataset.targetid === undefined ? false : '#' + answer.dataset.targetid
      )

      if (
        (answer.checked && !otherInput) ||
        (answer.checked && otherInput && otherInput.value.length)
      ) {
        checkedNumber++
      }
    })

    if (required === true || checkedNumber > 0) {
      if (min && checkedNumber < min) {
        error = true
      }

      if (max && checkedNumber > max) {
        error = true
      }
    }

    if (error) {
      answers.forEach(function (answer) {
        answer.parentElement.classList.add('invalid')
      })

      window.scrollTo({
        top: question.offsetTop - 125,
        behavior: 'smooth',
      })
    } else {
      answers.forEach(function (answer) {
        answer.parentElement.classList.remove('invalid')
      })
    }
  }

  return error
}

const bindCheckboxAction = question => {
  let answers = $$('input[type="checkbox"]', question)
  answers.forEach(answer => {
    answer.addEventListener('change', event => {
      toggleCheckbox(event.target)
    })
    if (answer.checked) {
      toggleCheckbox(answer)
    }
  })
}

const toggleCheckbox = checkbox => {
  if (checkbox.disabled) {
    return false
  }

  if (checkbox.dataset.targetid != undefined) {
    const other = $('#' + checkbox.dataset.targetid, checkbox.parentNode)
    other.disabled = !checkbox.checked
  }

  checkbox.parentNode.classList.toggle('quiz__question__answer--selected')
}

const bindTextareaAction = question => {
  const textarea = $('textarea', question)
  const counter = $('.questionnaire__question--counter', question)

  textarea.addEventListener('keyup', event => {
    const target = event.target
    let length = target.value.length

    if (!(target.maxlength == undefined) && length >= target.maxlength) {
      event.preventDefault()
      return false
    }

    counter.innerText = target.value.length
  })

  const event = new KeyboardEvent('keyup', {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  textarea.dispatchEvent(event)
}

// TODO: zmodyfikować pod formularz ankiety!!
const send = event => {
  submitBtn.disabled = true
  const loadContainer = $('#load-container')
  const errorMessageContainer = $('#error-message')

  errorMessageContainer.style.display = 'none'

  event.preventDefault()
  const XHR = new XMLHttpRequest()
  XHR.onreadystatechange = e => {
    if (XHR.readyState === XMLHttpRequest.DONE) {
      if (XHR.status === 200) {
        const res = JSON.parse(XHR.responseText)
        window.location.href = res.redirect
      } else {
        submitBtn.disabled = false
        loadContainer.style.display = 'none'
        errorMessageContainer.style.display = 'block'
      }
    }
  }

  let error = false
  questions.some(function (question) {
    error = validateQuestion(question)
    return error === true
  })

  if (error === false) {
    loadContainer.style.display = 'block'
    const $form = $('#questionnaire-form')
    const action = $form.action
    const data = new FormData($form)
    XHR.open('POST', action)
    XHR.send(data)
  } else {
    submitBtn.disabled = false
  }
}

if ($('section.questionnaire form')) {
  document.addEventListener('DOMContentLoaded', init)
}
